import { Button, IconButton, Paper, Slide, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import React from 'react';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import RelatorioBeneficiariosApi from '../../api/RelatorioBeneficiariosApi';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
  },
  divPrincipal: {
    width: '100%',
    display: 'table'
  },
  divSelecaoArquivo: {
    width: '1200px',
    display: 'table-cell'
  },
  divBotoes: {
    display: 'table-cell'
  },
  typography: {
    display: 'inline',
    margin: theme.spacing(2),
  },
  centralizado: {
    textAlign: 'center'
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});
class GerarArquivoBenef extends React.Component {
  relatorioBeneficiariosApi = new RelatorioBeneficiariosApi();
  state = {
    fileContent: [],
    fileContentDep: [],
    fetching: false,
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: 'Arquivo gerado com sucesso.',
    sucesso: true,
}

  handleClickGerarArquivo = async () => {
    this.setState({fetching: true});
    await this.consultarBeneficiariosCaixa();
    this.setState({fetching: false, snackOpen: true});
  }

  handleClickGerarArquivoDep = async () => {
    this.setState({fetching: true});
    await this.consultarBeneficiariosCaixaDep();
    this.setState({fetching: false, snackOpen: true});
  }

  consultarBeneficiariosCaixa = async () => {
    let nomeArquivo = '';
    nomeArquivo = 'carga_beneficiarios.txt';
    const fileContent = await this.relatorioBeneficiariosApi.gerarArquivo();
    this.setState({ fileContent: fileContent });
    this.gerarArquivo(nomeArquivo);
  }  

  consultarBeneficiariosCaixaDep = async () => {
    let nomeArquivo = '';
    nomeArquivo = 'carga_beneficiarios_dep.txt';
    const fileContentDep = await this.relatorioBeneficiariosApi.gerarArquivoDep();
    this.setState({ fileContentDep: fileContentDep });
    this.gerarArquivoDep(nomeArquivo);
  }  
  gerarArquivo = (nomeArquivo) => {
    let conteudo = '';
    let fileContent = this.state.fileContent;

    for (var i = 0; i < fileContent.length; i++) {
      conteudo = conteudo + fileContent[i].nome + '\n';
    }
    const url = window.URL.createObjectURL(new Blob([conteudo]), {type: 'text/plain;charset=ANSI'});
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
  gerarArquivoDep = (nomeArquivo) => {
    let conteudo = '';
    let fileContent = this.state.fileContentDep;

    for (var i = 0; i < fileContent.length; i++) {
      conteudo = conteudo + fileContent[i].nome + '\n';
    }
    const url = window.URL.createObjectURL(new Blob([conteudo]), {type: 'text/plain;charset=ANSI'});
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }

  render () {
    const { classes } = this.props;
    const { fetching } = this.state;
    return (
      <React.Fragment>
        <Link to='/caixaSaude' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Geração do Arquivo de Beneficiários</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.root} elevation={1}>
          <div className={classes.divPrincipal}>
            <div className={classes.divBotoes}>
              <Button
                color='primary'
                variant='outlined'
                className={classes.button}
                onClick={this.handleClickGerarArquivo}>
                Gerar Arquivo Titular
              </Button>
            </div>
          </div>
        </Paper>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.root} elevation={1}>
          <div className={classes.divPrincipal}>
            <div className={classes.divBotoes}>
              <Button
                color='primary'
                variant='outlined'
                className={classes.button}
                onClick={this.handleClickGerarArquivoDep}>
                Gerar Arquivo Dependente
              </Button>
            </div>
          </div>
        </Paper>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          duration={3000}
          handleClose={this.handleCloseSnackbar} />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(GerarArquivoBenef);
